import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';

const Headline = ({ children, size, uppercase }) => {
  const sizes = {
    h1: { px: 48, rem: 3 },
    h2: { px: 36, rem: 2.25 },
    h3: { px: 24, rem: 1.5 },
    h4: { px: 20, rem: 1.25 },
  };

  const props = {
    css: css`
      font-size: ${sizes[size].px}px;
      font-size: ${sizes[size].rem}rem;
      ${uppercase &&
      css`
        text-transform: uppercase;
      `};
    `,
  };

  return jsx(size, props, children);
};

Headline.defaultProps = {
  size: 'h1',
  uppercase: false,
};

Headline.propTypes = {
  children: PropTypes.node.isRequired,
  uppercase: PropTypes.bool,
  size: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
};

export default Headline;
